
export const Data = [
  {
    type:"zh",
    content: {
      boxImg:{
        type:"img",
        urlData:"http://116.62.38.250//image/ykb/nr/news/banner.jpg"
      },
      itemData:[
        {
          showData:false,
          path:{
            type: "text",
            content:"db"
          },
          content:[
            {
              type:{
                type: "text",
                content:"text"
              },
              item: "第二十五届中国东北国际口腔器材展览会暨学术交流会将于2024年3月22日-25日在沈阳新世界博览馆举行，东北国际口腔展(CNDE)从1999年起连续举办,展览面积24000平方米，参展企业575家。目前已经发展成为中国口腔行业的专业性盛会之一。成为继北京、上海、广州之后的国内第四大口腔专业展览会。\n" +
                "\n" +
                "微创未来将携口腔Er:YAG激光治疗仪新产品精彩亮相，我们期待与您在展会上相聚，共同书写舒适化激光领域的崭新篇章！\n" +
                "\n" +
                "微创未来诚邀您莅临展位，深入了解铒激光的舒适化微创解决方案，与我们共同见证激光的新未来！",
            },
            {
              type:{
                type: "text",
                content:"img"
              },
              item: "http://116.62.38.250//image/ykb/nr/news/db.jpg",
            }
          ]
        },
        {
          showData:false,
          path:{
            type: "text",
            content:"ljrc"
          },
          content:[
            {
              type:{
                type: "text",
                content:"text"
              },
              item: "双项领军人才计划加持，牙客邦口腔Er:YAG激光治疗仪引领口腔治疗新风潮！\n" +
                "牙客邦在创新与科技的道路上不断前行，凭借卓越的研发实力和技术创新，迎来了双重荣誉：2023年12月，我们荣获了第二批苏州东吴科技领军人才计划的高度认可，2024年，我们再次斩获第一批苏州姑苏创新创业领军人才计划项目。这些殊荣不仅是对牙客邦团队在口腔医疗领域杰出贡献的肯定，更是对我们创新产品市场潜力的充分认可。\n" +
                "\n" +
                "作为国内获得国家三类认证的口腔Er:YAG激光治疗仪的研发企业，牙客邦始终走在科技前沿。我们的口腔Er:YAG激光治疗仪通过精准、微创的治疗方式，大幅提升了口腔医疗的治疗效果。该设备凭借其高效、安全和舒适的治疗特点，成为现代口腔治疗领域的一次技术革新，受到越来越多医生和患者的青睐。\n" +
                "\n" +
                "东吴科技领军人才计划的获得，证明了我们在舒适化口腔医疗设备研发中的创新实力。而入选姑苏创新创业领军人才计划，更是对我们产品商业化落地和未来市场前景的认可。在这些强有力的政策支持下，牙客邦将继续深耕口腔医疗领域，推动口腔Er:YAG激光治疗技术的普及应用，为国内外的口腔医疗机构提供更高效、精准的解决方案。牙客邦创始团队表示：“这两项荣誉不仅是对我们团队和产品的极大肯定，更为我们未来的发展注入了强大动力。我们将不忘初心，坚持技术创新，为口腔医疗行业带来更多突破性的改变。”未来，牙客邦将继续坚持科技创新，助力口腔激光治疗设备的全面升级，推动行业技术进步。每一份荣誉，都是我们不断创新、敢于突破的见证；每一项成果，都是团队共同努力的结晶。牙客邦坚信，在双项领军人才计划的加持下，我们的口腔Er:YAG激光治疗仪将为更多患者带来福音，也将成为口腔医疗设备领域的标杆产品。",
            },
            {
              type:{
                type: "text",
                content:"img"
              },
              item: "http://116.62.38.250//image/ykb/nr/news/ljrw.png",
            }
          ]
        },
        {
          showData:false,
          path:{
            type: "text",
            content:"xb"
          },
          content:[
            {
              type:{
                type: "text",
                content:"text"
              },
              item: "喜报！国内口腔Er:YAG激光治疗仪获批，成功填补国内该领域空白\n" +
                "2024年04月08日  文章摘自LifeBay \n" +
                "近日，由LifeBay园内企业\n" +
                "苏州牙客邦医疗科技有限公司的全资子公司\n" +
                "微创未来（北京）激光技术有限公司自主研发的\n" +
                "国内口腔Er:YAG激光治疗仪\n" +
                "获批三类医疗器械注册证\n" +
                "这是牙科医疗行业里程碑式的科研成果\n" +
                "及产品研发成果\n" +
                "成功地填补了国内在该领域的空白\n" +
                "\n" +
                "\n" +
                "据国家药监局2024年03月25日医疗器械批准证明文件公示显示，国内口腔Er:YAG激光治疗仪获批三类医疗器械注册证。该产品（注册证号：国械注准20243010581）由苏州牙客邦医疗科技有限公司的全资子公司微创未来（北京）激光技术有限公司自主研发。据了解，该产品获得多项发明技术专利，这一创新成果不仅标志着国内口腔医疗设备领域的一大突破，打破了国外品牌的垄断，填补国内国产产品该领域的空白，更意味着中国口腔医疗激光技术与国际接轨，迈入领先行列，提高国内医疗设备产业的国际竞争力。相比传统进口牙科激光治疗仪，做到了低成本、易推广、易操作和效果好。该产品一旦推向市场，将广泛应用于牙周、种植、修复、美白、正畸、儿牙以及牙颌颜面美容等，未来可能会发展成口腔舒适化治疗的标准配置。",
            },
            {
              type:{
                type: "text",
                content:"img"
              },
              item: "http://116.62.38.250//image/ykb/nr/xb/3.png",
            },
            {
              type:{
                type: "text",
                content:"text"
              },
              item: "随着现代医学技术的飞速发展和消费者口腔健康意识的增强，口腔健康逐渐成为大众关注焦点。据口腔行业数据显示，2023年我国口腔医疗机构约20万家，所拥有口腔综合治疗椅高达200万张左右。与台湾和欧美市场的渗透率相比，我国口腔激光市场渗透率仍然有巨大的提升空间，预计口腔机构和诊椅数量以年12%复合速度增长，我国口腔精准舒适化诊疗市场规模预计到2030年将逼近1000亿，口腔铒激光作为口腔舒适化的代表产品成为口腔健康领域的一大亮点。\n" +
                "口腔铒激光设备可广泛应用于口腔全组织（软组织和硬组织）的临床治疗，目前该市场为美国和以色列等四家国际品牌所垄断。为了改变这一局面，国家层面早已提出“国产替代”的产业扶持政策，财政部国库司关于《政府采购进口产品审核指导标准》（2021年版）的通知中要求“牙科激光治疗仪”全部100%采用国产设备（见目录第241项）。由微创未来（北京）激光技术有限公司自主研发的口腔Er:YAG激光治疗仪获批通过，高度符合政策要求，打破了国外品牌的垄断，是继芯片、新能源、高铁等之后在高端医疗设备发起的一次国产替代冲锋。是这一政策在牙科医疗领域实实在在的落地。\n" +
                "口腔Er:YAG激光治疗仪获批通过标志着微创未来（北京）激光技术有限公司在口腔激光领域的深入布局取得了实质性进展，也显示出公司在创新激光领域研发方面的强大实力，展现了公司的创新能力和市场敏锐度。该公司目前建立了首条口腔铒激光治疗仪规模化生产线，这在国内尚属首次。完成铒激光在国内医疗领域的多个突破：成功取得国内首张口腔铒激光治疗领域的注册证、、国内首条口腔Er:YAG激光治疗仪产品规模化生产线、行业领先地位。\n" +
                "口腔行业资深专家刘会长说，微创未来（北京）激光技术有限公司推动了铒激光在牙科治疗仪应用方面的科技发展，助力口腔激光治疗仪由“高端体验”向“日常应用”的转型，大大提升治疗的安全性与舒适感，占据“生命健康”和“新材料”两大科创高地。口腔Er:YAG激光治疗仪不仅代表着微创未来技术的飞跃，更象征着医疗领域未来无限的可能，将为医生和患者带来前所未有的体验，是值得您一探究竟的科技新宠。\n" +
                "牙客邦董事长王铭辉先生表示，公司将继续深耕口腔激光领域，秉承“以人为本、科技创新”的理念，不断提升产品的质量和性能，为口腔激光事业贡献更多的力量。同时，我们也期待与更多的合作伙伴携手共进，共同推动口腔医疗器械行业的发展，为人类的健康事业贡献更多的智慧和力量。",
            },
            {
              type:{
                type: "text",
                content:"img"
              },
              item: "http://116.62.38.250//image/ykb/nr/xb/1.png",
            },
            {
              type:{
                type: "text",
                content:"img"
              },
              item: "http://116.62.38.250//image/ykb/nr/xb/2.gif",
            },
            {
              type:{
                type: "text",
                content:"text"
              },
              item: "苏州吴中生物医药产业园（LifeBay）是苏州市首批（2019年）市级生物医药产业园之一，总规划面积4.8平方公里，是吴淞江科技城的重要组成部分之一。产业园聚焦以偶联药物、核酸、蛋白降解、细胞与基因、抗体与小分子等为代表的创新药物与疗法，关注以医学影像、数字诊断、介入耗材等为代表的高值医疗器械，深入药械服务外包、核心原料与耗材等产业链上下游布局，打造以临床价值为出发点，全链条并举的生物医药创新加速基地。同时结合吴中智能制造(机器人)特色，培育AI医药产业。产业园另配套规模50亿元的生物医药专项基金，以培育助力优质项目发展壮大。\n" +
                "在动脉网2023未来医疗100强·澎湃奖的评选中，苏州吴中生物医药产业园获评年度生物医药标杆产业园。",
            }
          ]
        },
        {
          showData:false,
          path:{
            type: "text",
            content:"jxll"
          },
          content:[
            {
              type:{
                type: "text",
                content:"text"
              },
              item: "惊喜连连！铒激光惊艳亮相苏州口腔种植大会\n" +
                "2024年06月28日 ",
            },
            {
              type:{
                type: "text",
                content:"img"
              },
              item: "http://116.62.38.250//image/ykb/nr/jxll/1.jpg",
            },
            {
              type:{
                type: "text",
                content:"text"
              },
              item: "2024年7月4日至6日，由中华口腔医学会主办的第十五次口腔种植学术会议将在苏州国际会议酒店进行。微创未来携国产首台口腔Er:YAG 激光治疗仪隆重登场。口腔Er:YAG 激光治疗仪适用于种植体周围炎的治疗，可以为患者提供更为精准、高效的诊疗服务。我们在A06展位恭候大家的光临，期待与各位专家学者交流互动，一起聊聊口腔医疗的新鲜事儿，亲眼见证这项革新技术如何改变口腔治疗。",
            },
            {
              type:{
                type: "text",
                content:"img"
              },
              item: "http://116.62.38.250//image/ykb/nr/jxll/2.jpg",
            },
            {
              type:{
                type: "text",
                content:"text"
              },
              item: "展会时间：2024年7月4日-6日 \n" +
                "展会地点：苏州国际会议酒店 \n" +
                "展 位 号：A06",
            },
            {
              type:{
                type: "text",
                content:"img"
              },
              item: "http://116.62.38.250//image/ykb/nr/jxll/3.jpg",
            },
            {
              type:{
                type: "text",
                content:"text"
              },
              item: "展会亮点\n" +
                "\n" +
                "酷炫演示：现场操作铒激光治疗仪，展示其在临床上的神奇疗效\n" +
                "\n" +
                "专家坐镇：一对一解答铒激光技术的各种疑问，助您深入了解\n" +
                "\n" +
                "亲身体验：亲自感受无痛、微创的口腔治疗新体验，体验未来科技\n" +
                "\n" +
                "\n" +
                "为什么选择铒激光治疗种植体周围炎？\n" +
                "\n" +
                "\n" +
                "\t铒激光是目前治疗种植体周围炎最有效的手段!\n" +
                "\n" +
                "临床疗效：\n" +
                "\n" +
                "1、铒激光可有效祛除种植体表面及周围炎性肉芽组织，保证清创的效果\n" +
                "2、同时可精确去除术区不健康牙槽骨及软组织\n" +
                "3、可辅助诱导骨生长，加速骨结合\n" +
                "4、不会损伤种植体表面处理\n" +
                "5、研究证明，激光有灭菌效果\n" +
                "\n" +
                "病人体验：\n" +
                "舒适体验，术后反应轻，愈合周期缩短，治疗彻底，无需多次复诊。",
            },{
              type:{
                type: "text",
                content:"img"
              },
              item: "http://116.62.38.250/image/ykb/nr/jxll/4.jpg",
            },
            {
              type:{
                type: "text",
                content:"img"
              },
              item: "http://116.62.38.250//image/ykb/nr/jxll/5.jpg",
            },
          ]
        }
      ]







    }

  },
  {
    type:"en",
    text1:"英文"
  }
];



// WEBPACK FOOTER //
// ./src/components/js/newsItem.js